import EshopConfiguration from "../services/EshopConfiguration";
import newcomerPopupService from "./NewcomerPopupService";
import scrollTopButtonService from "./ScrollTopButtonService";
import promoHeaderBarService from "./PromoHeaderBarService";
import switchCountryPopupService from "./SwitchCountryPopupService";

export default new class EshopGeneralPageService {
    public init(eshopConfiguration: EshopConfiguration): void {
        scrollTopButtonService.init();
        newcomerPopupService.init(eshopConfiguration);
        switchCountryPopupService.init(eshopConfiguration);
        promoHeaderBarService.init(eshopConfiguration);
    }
}();
